import CardManagement from "containers/PaymentMethodManagement/CardManagement";
import PayoutManagement from "containers/PayoutManagement/PayoutManagement";

const PaymentMethodManagement = () => {
  return (
    <div
      className={`bg-offWhite p-4 mx-auto flex-col flex gap-8 h-screen md:w-[65vw] overflow-scroll no-scrollbar`}
    >
      <CardManagement />
      <PayoutManagement />
    </div>
  );
};

export default PaymentMethodManagement;
